import OrderItemInrixVolumesSidebar from "./inrixVolumes/OrderItemInrixVolumesSidebar";

interface FeatureSidebarsProps {
  // Can extend with more props as needed for different sidebar types
}

const FeatureSidebars = ({}: FeatureSidebarsProps) => {
  return (
    <>
      <OrderItemInrixVolumesSidebar />
    </>
  );
};

export default FeatureSidebars;
